"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ReducerRegistry = void 0;

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/reduce"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/values"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/array/from"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/map"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var ReducerRegistry = /*#__PURE__*/function () {
  function ReducerRegistry(defaultState) {
    (0, _classCallCheck2.default)(this, ReducerRegistry);
    this.reducers = new _map.default();
    this.untypedReducers = [];
    this.epics = new _map.default();
    this.defaultState = void 0;
    this.defaultState = defaultState;
  }

  (0, _createClass2.default)(ReducerRegistry, [{
    key: "setDefaultState",
    value: function setDefaultState(defaultState) {
      this.defaultState = defaultState;
    }
  }, {
    key: "getDefaultState",
    value: function getDefaultState() {
      return this.defaultState;
    }
  }, {
    key: "add",
    value: function add(actionTypeOrReducer, reducer) {
      var actionType;

      if (typeof actionTypeOrReducer === 'string') {
        actionType = actionTypeOrReducer;

        if (!reducer) {
          throw new TypeError('Reducer is required');
        }

        this.reducers.set(actionType, reducer);
      } else {
        this.untypedReducers.push(actionTypeOrReducer);
      }
    } // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "addEpic",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: function addEpic(key, epic) {
      if (typeof key === 'function') {
        epic = key;
      }

      if (epic === undefined) {
        throw new TypeError('Epic is required');
      }

      this.epics.set(key, epic);
      return epic;
    }
  }, {
    key: "getEpics",
    value: function getEpics() {
      var _context;

      return (0, _from.default)((0, _values.default)(_context = this.epics).call(_context));
    }
  }, {
    key: "getReducer",
    value: function getReducer() {
      var _this = this;

      var defaultState = this.defaultState;
      return function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
        var action = arguments.length > 1 ? arguments[1] : undefined;

        if (_this.untypedReducers.length > 0) {
          var _context2;

          state = (0, _reduce.default)(_context2 = _this.untypedReducers).call(_context2, function (currentState, currentReducer) {
            var nextState = currentReducer(currentState, action);
            return nextState;
          }, state);
        }

        var reducer = _this.reducers.get(action.type);

        if (reducer !== undefined) {
          return reducer(state, action);
        }

        return state;
      };
    }
  }]);
  return ReducerRegistry;
}();

exports.ReducerRegistry = ReducerRegistry;